import React from 'react';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import { makeStyles, TablePagination } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const createRows = (data) => {
  const rows = [];
  for (let i = 0; i < data.length; i++) {
    const row = {
      id                 : data[i]?.id || '',
      requestType        : data[i]?.requestType || '',
      tcnCustomerId      : data[i]?.tcnCustomerId || '',
      createdBy          : data[i]?.actorInfo?.email || '',
      environment        : data[i]?.environment || '',
      priorValue         : data[i]?.priorValue || '',
      updatedValue       : data[i]?.updatedValue || '',
      createdAt          : data[i]?.createdAt || ''
    };

    rows.push(row);
  }
  return rows;
};

const UserListTable = ({
  ipList,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPage,
  totalRowCount,
  page
}) => {
  const classes = useStyles();
  const rows = ipList?.length > 0 ? createRows(ipList) : [];

  return (
    <>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer component={Paper} className="table-container">
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Id </TableCell>
                <TableCell align="left">RequestType </TableCell>
                <TableCell align="left">TCNCustomerId </TableCell>
                <TableCell align="left">TestEnvironment</TableCell>
                <TableCell align="left">PriorValue</TableCell>
                <TableCell align="left">UpdatedValue</TableCell>
                <TableCell align="left">CreatedAt</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length > 0 ? (
                rows.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell align="left">{row.id}</TableCell>
                    <TableCell align="left">{row.requestType}</TableCell>
                    <TableCell align="left">{row.tcnCustomerId}</TableCell>
                    <TableCell align="left">{row.environment}</TableCell>
                    <TableCell align="left">{JSON.stringify(row.priorValue) }</TableCell>
                    <TableCell align="left">{JSON.stringify(row.updatedValue)}</TableCell>
                    <TableCell align="left">
                      {row.createdAt
                        ? format(parseISO(row.createdAt), 'yyyy-MM-dd HH:mm:ss')
                        : '-'}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow style={{ height: 53 * 1 }}>
                  <TableCell colSpan={6}>
                    {' '}
                    No data available in table{' '}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={totalRowCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </>
  );
};

UserListTable.propTypes = {
  ipList: PropTypes.array,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  totalRowCount: PropTypes.number
};

export default UserListTable;
